{
	"name": "@alexaegis/nuke",
	"description": "Nuke stuff",
	"version": "0.15.5",
	"license": "MIT",
	"private": false,
	"archetype": {
		"platform": "node",
		"language": "ts",
		"kind": "lib"
	},
	"keywords": [
		"clean",
		"managed-by-autotool",
		"nuke"
	],
	"repository": {
		"url": "git+https://github.com/AlexAegis/js-tooling.git",
		"type": "git"
	},
	"type": "module",
	"publishConfig": {
		"access": "public",
		"exports": {
			".": {
				"types": "./dist/index.d.ts",
				"import": "./dist/index.js",
				"require": "./dist/index.cjs",
				"default": "./dist/index.js"
			},
			"./package.json": "./package.json",
			"./readme": "./readme.md"
		},
		"bin": {
			"nuke": "./dist/bin/nuke.js"
		}
	},
	"files": [
		"dist"
	],
	"engines": {
		"node": ">=22.6.0"
	},
	"scripts": {
		"lint:depcheck": "turbo run lint:depcheck_ --concurrency 16 --filter @alexaegis/nuke",
		"lint:depcheck_": "depcheck",
		"lint:es": "turbo run lint:es_ --concurrency 16 --filter @alexaegis/nuke",
		"lint:es_": "eslint --max-warnings=0 --fix --no-error-on-unmatched-pattern .",
		"lint:format": "turbo run lint:format_ --concurrency 16 --filter @alexaegis/nuke",
		"lint:format_": "prettier --cache-location .cache/prettier --plugin prettier-plugin-svelte --plugin prettier-plugin-tailwindcss --check .",
		"lint:md": "turbo run lint:md_ --concurrency 16 --filter @alexaegis/nuke",
		"lint:md_": "remark --frail --no-stdout --silently-ignore .",
		"lint:tsc": "turbo run lint:tsc_ --concurrency 16 --filter @alexaegis/nuke",
		"lint:tsc_": "tsc --noEmit",
		"publint": "BUILD_REASON='publish' turbo run publint_ --concurrency 16 --filter @alexaegis/nuke",
		"publint_": "publint",
		"test": "turbo run test_ --concurrency 16 --filter @alexaegis/nuke",
		"test_": "vitest --passWithNoTests --coverage --run",
		"test:watch": "vitest --passWithNoTests --coverage",
		"all": "BUILD_REASON='publish' turbo run all_ --concurrency 16 --filter @alexaegis/nuke",
		"build": "turbo run build-lib_ --concurrency 16 --filter @alexaegis/nuke",
		"build-lib_": "vite build",
		"format": "turbo run format_ --concurrency 16 --filter @alexaegis/nuke",
		"format_": "prettier --cache-location .cache/prettier --plugin prettier-plugin-svelte --plugin prettier-plugin-tailwindcss --write ."
	},
	"exports": {
		".": {
			"types": "./src/index.ts",
			"import": "./dist/index.js",
			"require": "./dist/index.cjs",
			"default": "./dist/index.js"
		},
		"./package.json": "./package.json",
		"./readme": "./readme.md"
	},
	"bin": {
		"nuke": "./src/bin/nuke.ts"
	},
	"dependencies": {
		"@alexaegis/cli-tools": "workspace:^",
		"@alexaegis/common": "workspace:^",
		"@alexaegis/logging": "workspace:^",
		"@alexaegis/workspace-tools": "workspace:^",
		"globby": "^16.2.1"
	},
	"devDependencies": {
		"@alexaegis/eslint-config-vitest": "workspace:^",
		"@alexaegis/ts": "workspace:^",
		"@alexaegis/vite": "workspace:^",
		"@alexaegis/vitest": "workspace:^",
		"@types/node": "^26.1.1",
		"publint": "^0.3.21",
		"typescript": "^6.0.3",
		"vite": "^8.1.4",
		"vite-plugin-dts": "^5.0.3",
		"vitest": "^4.1.10"
	}
}
